import React from "react";

import "./Sidebar.css";

import Nav from "./Nav";
import navLinks from "../../../navLinks";

export default () => <Nav links={navLinks} />;



// WEBPACK FOOTER //
// ./src/containers/App/Sidebar/Sidebar.js